module.exports = __webpack_public_path__ + "static/media/xiantiaoxia.622e6793.png";